import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackCommunityCreatedSpec,
  trackCommunitySearchedSpec,
  trackCommunityViewedSpec,
  trackCpdDraftCreatedSpec,
  trackCpdDraftDeletedSpec,
  trackCpdDraftResumedSpec,
  trackCpdExportedSpec,
  trackCpdPageViewedSpec,
  trackTaskCompletedSpec,
  trackTaskCreatedSpec,
  trackTaskDelegatedSpec,
  trackTaskDeletedSpec,
  trackTaskListViewedSpec,
  trackTaskNotificationClickedSpec,
  trackTaskUpdatedSpec,
  trackTaskViewedSpec,
  type CommunityCreated,
  type CommunitySearched,
  type CommunityViewed,
  type CpdDraftCreated,
  type CpdDraftDeleted,
  type CpdDraftResumed,
  type CpdExported,
  type CpdPageViewed,
  type TaskCompleted,
  type TaskCreated,
  type TaskDelegated,
  type TaskDeleted,
  type TaskListViewed,
  type TaskNotificationClicked,
  type TaskUpdated,
  type TaskViewed,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const taskEvents: SnowplowEventMap = {
  [TrackingEventName.TaskCreated]: (props) => trackTaskCreatedSpec(props as TaskCreated),
  [TrackingEventName.TaskCompleted]: (props) =>
    trackTaskCompletedSpec(props as TaskCompleted),
  [TrackingEventName.TaskDeleted]: (props) => trackTaskDeletedSpec(props as TaskDeleted),
  [TrackingEventName.TaskUpdated]: (props) => trackTaskUpdatedSpec(props as TaskUpdated),
  [TrackingEventName.TaskViewed]: (props) => trackTaskViewedSpec(props as TaskViewed),
  [TrackingEventName.TaskListViewed]: (props) =>
    trackTaskListViewedSpec(props as TaskListViewed),
  [TrackingEventName.TaskNotificationClicked]: (props) =>
    trackTaskNotificationClickedSpec(props as TaskNotificationClicked),
  [TrackingEventName.TaskDelegated]: (props) =>
    trackTaskDelegatedSpec(props as TaskDelegated),
  [TrackingEventName.CommunityViewed]: (props) =>
    trackCommunityViewedSpec(props as CommunityViewed),
  [TrackingEventName.CommunitySearched]: (props) =>
    trackCommunitySearchedSpec(props as CommunitySearched),
  [TrackingEventName.CommunityCreated]: (props) =>
    trackCommunityCreatedSpec(props as CommunityCreated),
  [TrackingEventName.CPDPageViewed]: (props) =>
    trackCpdPageViewedSpec(props as CpdPageViewed),
  [TrackingEventName.CPDExported]: (props) => trackCpdExportedSpec(props as CpdExported),
  [TrackingEventName.CPDDraftCreated]: (props) =>
    trackCpdDraftCreatedSpec(props as CpdDraftCreated),
  [TrackingEventName.CPDDraftResumed]: (props) =>
    trackCpdDraftResumedSpec(props as CpdDraftResumed),
  [TrackingEventName.CPDDraftDeleted]: (props) =>
    trackCpdDraftDeletedSpec(props as CpdDraftDeleted),
};
